export default __webpack_public_path__ + "static/media/stokerverse-rpg-tales.360279d4.png";